export const votingPeriodItems = [
  {
    value: "1",
    label: "24 hrs",
  },
  {
    value: "2",
    label: "48 hrs",
  },
  {
    value: "3",
    label: "72 hrs",
  },
  {
    value: "7",
    label: "One Week",
  },
  {
    value: "14",
    label: "Two Weeks",
  },
];
export const votingParams = [
  {
    value: true,
    label: "Custom Voting Parameters",
  },
  {
    value: false,
    label: "Default Voting Parameters",
  },
];
export const votingDelayItems = [
  {
    value: "0",
    label: "Instant",
  },
  {
    value: "1",
    label: "24 hrs",
  },
  {
    value: "2",
    label: "48 hrs",
  },
  {
    value: "3",
    label: "72 hrs",
  },
  {
    value: "7",
    label: "One Week",
  },
  {
    value: "14",
    label: "Two Weeks",
  },
];
